import { useEffect, useRef, useState } from "react";

export const TypeTerminal = ({
    prompt = "agentvm@runtime:~$",
    command = "boot",
    lines = [],
    statusRows = [],
    footer = "SYSTEM READY_",
    loop = true,
    className = "",
    testid = "type-terminal",
}) => {
    const [phase, setPhase] = useState(0); // 0 typing cmd, 1 streaming lines, 2 status, 3 footer
    const [cmdChars, setCmdChars] = useState(0);
    const [lineIdx, setLineIdx] = useState(0);
    const [statusIdx, setStatusIdx] = useState(0);
    const timer = useRef(null);

    useEffect(() => {
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduced) {
            setCmdChars(command.length);
            setLineIdx(lines.length);
            setStatusIdx(statusRows.length);
            setPhase(3);
            return;
        }
        let cancelled = false;
        const tick = () => {
            if (cancelled) return;
            if (phase === 0) {
                if (cmdChars < command.length) {
                    timer.current = setTimeout(() => setCmdChars((c) => c + 1), 55);
                } else {
                    timer.current = setTimeout(() => setPhase(1), 300);
                }
            } else if (phase === 1) {
                if (lineIdx < lines.length) {
                    timer.current = setTimeout(() => setLineIdx((l) => l + 1), 200);
                } else {
                    timer.current = setTimeout(() => setPhase(2), 250);
                }
            } else if (phase === 2) {
                if (statusIdx < statusRows.length) {
                    timer.current = setTimeout(() => setStatusIdx((s) => s + 1), 170);
                } else {
                    timer.current = setTimeout(() => setPhase(3), 200);
                }
            } else if (loop) {
                timer.current = setTimeout(() => {
                    setCmdChars(0);
                    setLineIdx(0);
                    setStatusIdx(0);
                    setPhase(0);
                }, 6000);
            }
        };
        tick();
        return () => {
            cancelled = true;
            clearTimeout(timer.current);
        };
    }, [phase, cmdChars, lineIdx, statusIdx, command, lines, statusRows, loop]);

    return (
        <div data-testid={testid} className={`font-mono text-[11px] leading-5 sm:text-xs ${className}`}>
            <div className="text-[#B8C7D9]">
                <span className="text-[#00D9FF]">{prompt}</span> {command.slice(0, cmdChars)}
                {phase === 0 && <span className="vm-blink text-[#00D9FF]">▌</span>}
            </div>
            <div className="mt-3 space-y-0.5">
                {lines.slice(0, lineIdx).map((line, i) => (
                    <div key={i} className="text-[#B8C7D9]/85">
                        {line}
                    </div>
                ))}
            </div>
            {phase >= 2 && statusRows.length > 0 && (
                <div className="mt-4 border-t border-[rgba(0,217,255,0.15)] pt-3">
                    <div className="vm-micro-dim mb-2">SYSTEM STATUS</div>
                    {statusRows.slice(0, statusIdx).map(([k, v], i) => (
                        <div key={i} className="flex justify-between gap-6">
                            <span className="tracking-[0.14em] text-[#B8C7D9]/70">{k}</span>
                            <span className={v === "READY" || v === "VERIFIED" || v === "PROTECTED" || v === "BOUND" ? "text-emerald-300" : "text-[#00D9FF]"}>
                                [ {v} ]
                            </span>
                        </div>
                    ))}
                </div>
            )}
            {phase === 3 && (
                <div className="mt-4 text-[#00D9FF]">
                    {footer}
                    <span className="vm-blink">_</span>
                </div>
            )}
        </div>
    );
};
